import _regeneratorRuntime from 'babel-runtime/regenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import ProductInfoVerify from '@pt/components/product-info-dialog.vue';
import PtButton from '@com/pt-components/pt-button/index.vue';
import { PtButtonTheme as _PtButtonTheme, PtButtonType as _PtButtonType } from '@com/pt-components/pt-button/enum';
// import PushToSs from './push-to-ss.vue'
import { PtBusinessType } from '@pt/components/common-push-dialog/config';
import { materialMakeFrom } from '@pt/utils/push.js';

export default {
  props: {
    saveTemplateBeforePush: {
      type: Boolean,
      default: true
    }
  },

  components: {
    PtButton: PtButton,
    // PushToSs,
    ProductInfoVerify: ProductInfoVerify
  },

  data: function data() {
    return {
      downloadLoading: false,
      pushLoading: false,
      channelList: []
    };
  },


  computed: _extends({
    PtButtonTheme: function PtButtonTheme() {
      return _PtButtonTheme;
    },
    PtButtonType: function PtButtonType() {
      return _PtButtonType;
    }
  }, mapState({
    id: function id(state) {
      return state.creative.template.id;
    },
    isCommonTemplateCustom: function isCommonTemplateCustom(state) {
      return state.creative.template.isCommonTemplateCustom;
    },
    templateId: function templateId(state) {
      return _.get(state, 'creative.template.templateId');
    },
    promotedType: function promotedType(state) {
      return _.get(state, 'creative.template.templateConfig.promoted_type') || '';
    },
    pushPermissions: function pushPermissions(state) {
      return _.get(state, 'creative.template.templateConfig.is_pushable') || false;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    }
  }), {
    canPush: function canPush() {
      // 定制模板需要判断是否有推送权限，通用模板都有推送权限
      return this.pushPermissions || this.isCommonTemplateCustom;
    }
  }),

  mounted: function mounted() {},


  methods: _extends({}, mapActions({
    saveTemplate: 'creative/template/saveTemplate'
  }), {
    handleProductUpdate: function handleProductUpdate() {},
    download: function download() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var routeData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!_this.saveTemplateBeforePush) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this.saveTemplate();

              case 4:
                routeData = null;

                if (_this.isCommonTemplateCustom) {
                  routeData = _this.$router.resolve({
                    name: 'pl-viewer',
                    query: {
                      type: PtBusinessType.Normal,
                      id: _this.id,
                      from: materialMakeFrom.gmaker,
                      rowData: _JSON$stringify({
                        id: _this.id,
                        template_id: _this.templateId,
                        pushPermissions: _this.canPush,
                        name: _this.templateConfig.name,
                        project_type: 'normal'
                      })
                    }
                  });
                  window.open(routeData.href, '_blank');
                } else {
                  // 定制可玩普通制作
                  routeData = _this.$router.resolve({
                    name: 'pl-viewer',
                    query: {
                      type: PtBusinessType.CustomNormal,
                      id: _this.id,
                      from: materialMakeFrom.dmaker,
                      rowData: _JSON$stringify({
                        id: _this.id,
                        template_id: _this.templateId,
                        pushPermissions: _this.canPush,
                        isPtVersion: true
                      })
                    }
                  });
                  window.open(routeData.href, '_blank');
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);
                throw new Error(_context.t0);

              case 11:
                _context.prev = 11;

                _this.downloadLoading = false;
                return _context.finish(11);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8, 11, 14]]);
      }))();
    },
    handleDownload: function handleDownload() {
      if (this.$refs.productInfoVerifyRef) {
        this.$refs.productInfoVerifyRef.handleClick();
      }
    }
  })
};